var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "11", height: "5", viewBox: "0 0 11 5", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.04324 0.185579C9.35497 -0.0871823 9.82879 -0.0555941 10.1016 0.256133C10.3743 0.567861 10.3427 1.04168 10.031 1.31444L6.031 4.81444C5.74823 5.06187 5.32601 5.06187 5.04324 4.81444L1.04324 1.31444C0.731514 1.04168 0.699925 0.567859 0.972687 0.256132C1.24545 -0.0555956 1.71927 -0.0871836 2.031 0.185578L5.53712 3.25344L9.04324 0.185579Z", fill: "#303030" })
  );
});